import { Expose, plainToInstance, Type } from 'class-transformer';

import { ProductModel } from '@/entities/product/model';
import type { RestaurantMenu } from '@/shared/api';

export class RestaurantMenuModel {
  @Expose({ name: 'menu_id' })
  id: number;

  @Expose()
  name: string;

  @Expose()
  open_at: string;

  @Expose()
  close_at: string;

  @Expose()
  @Type(() => ProductModel)
  items: ProductModel[];
}

export const plainToInstanceRestaurantMenu = (plain: RestaurantMenu) =>
  plainToInstance(RestaurantMenuModel, plain, {
    excludeExtraneousValues: true,
  });
